import { render } from "./ReviewsDetail.vue?vue&type=template&id=960612a2&scoped=true"
import script from "./ReviewsDetail.vue?vue&type=script&lang=js"
export * from "./ReviewsDetail.vue?vue&type=script&lang=js"

import "./ReviewsDetail.vue?vue&type=style&index=0&id=960612a2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-960612a2"]])

export default __exports__